/* eslint-disable @nx/enforce-module-boundaries */
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Center,
  Container,
  Flex,
  HStack,
  Stack,
} from '@mybridge/ui/layout';
import { Button } from '@mybridge/ui/button';
import {
  CloseButton,
  Divider,
  IconButton,
  Link,
  Image,
  Text,
  useDisclosure,
  Spinner
} from '@mybridge/ui';
import { MyNetworkContext } from 'v4/components/network/context';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import {
  BookAppointment,
  CalendarIcon,
  ChatIcon,
  HandShakeSimpleIcon,
  VerticalThreeDot,
  ReminderIcon,
  ChatOutLined,
  ScheduleIcon,
  ThreeDot,
  FollowingIconV2,
  FollowIcon,
  HorizontalMenuIcon,
  CallIconNew,
  AcceptNewIcon,
  IgnoreNewIcon
} from '@mybridge/icons';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { PublicProfileMenu } from './menu';
import { isMobile } from 'react-device-detect';
import { MeetingDefaultIcon } from '@mybridge/icons/NotificationIcons';
import { scheduleMeetingWithUser } from 'v4/store/actions/meeting.actions';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { Tooltip } from '@chakra-ui/react';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import HandshakeUserModal from 'v4/components/network/handshake-user-modal';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { GlobalMatrixPopup } from 'v4/snippets/globalMatrixPopup';
import { getMatrixUserId, getRoomIdFromLS } from 'v4/utils/utils';
const RightProfileActionsPublic = ({ noFollow, ...props }) => {
  const {
    isFriend,
    myFirstDegreeConnections,
    isFollowed,
    followUser,
    followLoading,
    unfollowUser,
    handshakeUser,
    handshakeSelectedUser,
    setHandshakeSelectedUser,
    handshakeMessageDisc,
    isHandshaked,
    handleHandshakeSendRevoke,
    acceptInvitation,
    acceptInvitationLoading,
    isHandshakeRequested,
    setSelectedUser,
    requestsSent,
    pendingInvitations,
    rejectInvitation,
    rejectInvitationLoading,
    getRequestedAndSenderUserInfoFromUser,
    loadingPDF,
  } = useContext(MyNetworkContext);
  //for matrix id generation
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [nullMatrixUser, setNullMatrixUser] = useState(null);
  const [confirmAction, setConfirmAction] = useState(() => () => {});
  
  const dispatch = useDispatch();
  const router = useRouter();
  const { t } = useTranslator();
  const { userProfileInfo, publicProfile, refetchPublicProfile } = useContext(PublicProfileContext);

  const { feelings_activity } = publicProfile;
  const { startMeetingSingle, startChatSingle, initiateCall } = useContext(MatrixContext);

  const profileDataFromCircle = myFirstDegreeConnections?.find((user)=>user?.id === publicProfile?.id)

  const handleStartChatClick = (e) => {
    // startChatSingle(publicProfile);
    const roomId = profileDataFromCircle?.connection?.room_id || getRoomIdFromLS(publicProfile?.id);
    router.push(`/profile/message?user=${roomId}`);
  };

  const handleMeetNowClick = (e) => {
    startMeetingSingle(publicProfile);
  };

  const handleProfileHandshake = (user) => {
    setHandshakeSelectedUser(user);
    handshakeMessageDisc?.onOpen();
  };

  const handleScheduleMeeting = () => {
    dispatch(
      scheduleMeetingWithUser({ users: publicProfile, type: 'connection' })
    );
    router.push('/profile/calendar/schedule');
  };

  const getFeelingActivityGrammer = (category) => {
    switch (category) {
      case 'More':
        return '';
      case 'Attending':
        return 'Attending ';
      case 'Celebrating':
        return 'Celebrating ';
      case 'Feeling':
        return 'Feeling ';
      default:
        return '';
    }
  };
  return (
    <Stack
      direction={['column', 'row']}
      pl={['0', '0', '0']}
      pos="relative"
      zIndex="8"
      mt={[4, 2]}
    >
      <HStack gap="30px" my={[3, 3, 0]}>
        {userProfileInfo?.id === publicProfile?.id ? (
          <Box minW="140px"></Box>
        ) : (
          <>
            {!isMobile && (<HStack pl={4}>
              {isFollowed(publicProfile) ? (
                <Tooltip label={t('publicProfile.following') || "Following"} bg="black" p={2}>
                  <Box
                    _hover={{
                      bg: "gray.200"
                    }}
                    w={'41px'}
                    height={'41px'}
                    border={'1px solid #00000033'}
                    cursor="pointer"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius={'50%'}
                    onClick={(e) => unfollowUser(publicProfile)}
                  >
                    {/* <IconButton
                                onClick={(e) => {
                                  dispatch(unFollowCompanyPage(company?.id));
                                  dispatch(getAllConnectionIDs());
                                }}
                                isLoading={loading}
                                // isDisabled={isFollowed?.(user)}
                                // variant="primary"
                                icon={
                                  <FollowingIconV2 width="20" height="20" />
                                }
                                w="70px"
                              /> */}

                    <FollowingIconV2 width="18" height="18" />
                  </Box>
                </Tooltip>
              ) : (
                // <Tooltip label="Follow" bg="black" p={2}>

                //   <Box
                //     _hover={{
                //       bg: "gray.200"
                //     }}
                //     w={'41px'}
                //     height={'41px'}
                //     border={'1px solid #00000033'}
                //     cursor="pointer"
                //     display="flex"
                //     alignItems="center"
                //     justifyContent="center"
                //     borderRadius={'50%'}
                //     onClick={(e) => followUser(publicProfile)}
                //   >
                //     {/* <IconButton
                //             onClick={(e) => {
                //               dispatch(followCompanyPage(company?.id));
                //               dispatch(getAllConnectionIDs());
                //             }}
                //             isLoading={loading}
                //             // isDisabled={isFollowed?.(user)}
                //             // variant="primary"
                //             icon={<FollowIcon width="20" height="20" />}
                //             w="70px"
                //           /> */}

                //     <FollowIcon width="18" height="18" />
                //   </Box>

                // </Tooltip>
                <Tooltip label={t('publicProfile.follow') || "Follow"} bg="black" p={2}>
                  {publicProfile ? (
                    <ForceSignInWrapper>
                      <Box
                        _hover={{
                          bg: "gray.200"
                        }}
                        w={'41px'}
                        height={'41px'}
                        border={'1px solid #00000033'}
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius={'50%'}
                        onClick={(e) => followUser(publicProfile)}
                      >
                        <FollowIcon width="18" height="18" />
                      </Box>
                    </ForceSignInWrapper>
                  ) : (
                    <Box
                      _hover={{
                        bg: "gray.200"
                      }}
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      onClick={(e) => followUser(publicProfile)}
                    >
                      <FollowIcon width="18" height="18" />
                    </Box>
                  )}
                </Tooltip>
              )}

            </HStack>)}



            {/* {!noFollow && (
              <Box>
                {isFollowed(publicProfile) ? (
                  <Button
                    size="sm"
                    variant="secondary"
                    borderRadius="full"
                    onClick={(e) => unfollowUser(publicProfile)}
                  >
                    Following
                  </Button>
                ) : (
                  <Button
                    onClick={(e) => followUser(publicProfile)}
                    isLoading={followLoading}
                    size="sm"
                    variant="secondary"
                    borderRadius="full"
                  >
                    Follow
                  </Button>
                )}
              </Box>
            )} */}
          </>
        )}

        {/* {feelings_activity && (
          <Box
            borderRadius="full"
            px={3}
            py={1}
            className="primaryGradiantButton"
          >
            <HStack>
              <Flex
                width="25px"
                height="25px"
                bg="white"
                borderRadius="full"
                justifyContent="center"
                alignItems="center"
              >
                <Image src={feelings_activity?.file} width="22" height="22" />
              </Flex>
              <Text color="#fff" fontSize="14px">
                {getFeelingActivityGrammer(feelings_activity?.category)}
                {feelings_activity?.name}
              </Text>
            
            </HStack>
          </Box>
        )} */}
      </HStack>
      {isMobile ? (
        <HStack w="100%" justifyContent="end" flexWrap="nowrap" spacing="6px">
          {userProfileInfo?.id === publicProfile?.id ? (
            ''
          ) : isFriend?.(publicProfile) ? (
            <HStack justifyContent="flex-start">
              {!isMobile ? (
                <>
                  <Tooltip label={t('publicProfile.bookAppointment') || "Book Appointment"} bg="black" p={2}>
                    <Box
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      // onClick={(e) => {
                      //   router.push(`/profile/message?user=${publicProfile?.connection?.chat_room_id}`)
                      // }}
                      onClick={() => {
                        // const matrixUserId = getMatrixUserId(publicProfile?.id);
                        // setNullMatrixUser(publicProfile)

                        // if (!(publicProfile?.connection?.chat_room_id || matrixUserId)) {
                        //   setConfirmAction(() => (newId) => {
                        //     router.push(`/profile/message?user=${newId}`);
                        //   });
                        //   onOpen();
                        // } else {
                          router.push(`/profile/message?user=${publicProfile}`);
                        // }
                      }}
                      sx={{
                        _hover: {
                          backgroundColor: "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <ChatOutLined />
                    </Box>
                  </Tooltip>

                  {/* <Button
                    variant="secondary"
                    leftIcon={<ChatIcon width="20" height="20" />}
                    onClick={handleStartChatClick}
                  >
                    Message
                  </Button> */}
                  {/* <Button
                    onClick={handleMeetNowClick}
                    variant="secondary"
                    leftIcon={<MeetingDefaultIcon width="20" height="20" />}
                  >
                    Meet Now
                  </Button> */}
                  <Tooltip label={t('publicProfile.bookAppointment') || "BookAppointment"} bg="black" p={2}>
                    <Box
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      onClick={handleStartChatClick}
                      sx={{
                        _hover: {
                          backgroundColor: "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <MeetingDefaultIcon
                        height={'18px'}
                        width={'18px'}
                      />
                    </Box>
                  </Tooltip>
                  {publicProfile?.appointment_profile && (
                    <Tooltip label={t('publicProfile.bookAppointment') || "BookAppointment"} bg="black" p={2}>
                      <Box
                        w={'41px'}
                        height={'41px'}
                        border={'1px solid #00000033'}
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius={'50%'}
                        sx={{
                          _hover: {
                            backgroundColor: "#E4E6EB",
                            color: "inherit",
                          },
                        }}
                      >

                        <CalendarIcon
                          height={'18px'}
                          width={'18px'}
                          onClick={() => {
                            router.push(`/appointment/${publicProfile?.appointment_slug}`)
                          }}
                        />
                      </Box>
                    </Tooltip>
                    // <Button
                    //   onClick={() => {
                    //     router.push(`/appointment/${publicProfile?.appointment_slug}`)
                    //   }}
                    //   variant="secondary"
                    //   leftIcon={<BookAppointment width="20" height="20" />}
                    // >
                    //   Book Appointment
                    // </Button>
                  )}

                  <Tooltip label={t('publicProfile.bookAppointment') || "BookAppointment"} bg="black" p={2}>
                    <Box
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      sx={{
                        _hover: {
                          backgroundColor: "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <CalendarIcon
                        height={'18px'}
                        width={'18px'}
                        onClick={() => handleScheduleMeeting()}
                      />
                    </Box>
                  </Tooltip>
                  {/* <Button
                    variant="secondary"
                    leftIcon={<CalendarIcon width="20" height="20" />}
                    as={Link}
                    onClick={() => handleScheduleMeeting()}
                  >
                    Schedule
                  </Button> */}
                </>
              ) : (
                <>
                  {isFollowed(publicProfile) ? (
                    <Tooltip label={t('publicProfile.following') || "Following"} bg="black" p={2}>


                      <Box
                        _hover={{
                          bg: "gray.200"
                        }}
                        w={'34px'}
                        height={'34px'}
                        border={'1px solid #00000033'}
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius={'50%'}
                        onClick={(e) => unfollowUser(publicProfile)}
                      >
                        {/* <IconButton
                                onClick={(e) => {
                                  dispatch(unFollowCompanyPage(company?.id));
                                  dispatch(getAllConnectionIDs());
                                }}
                                isLoading={loading}
                                // isDisabled={isFollowed?.(user)}
                                // variant="primary"
                                icon={
                                  <FollowingIconV2 width="20" height="20" />
                                }
                                w="70px"
                              /> */}

                        <FollowingIconV2 width="16" height="16" />
                      </Box>
                    </Tooltip>
                  ) : (
                    <Tooltip label={t('publicProfile.follow') || "Follow"} bg="black" p={2}>
                      <Box
                        _hover={{
                          bg: "gray.200"
                        }}
                        w={'34px'}
                        height={'34px'}
                        border={'1px solid #00000033'}
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius={'50%'}
                        onClick={(e) => followUser(publicProfile)}
                      >
                        {/* <IconButton
                            onClick={(e) => {
                              dispatch(followCompanyPage(company?.id));
                              dispatch(getAllConnectionIDs());
                            }}
                            isLoading={loading}
                            // isDisabled={isFollowed?.(user)}
                            // variant="primary"
                            icon={<FollowIcon width="20" height="20" />}
                            w="70px"
                          /> */}

                        <FollowIcon width="16" height="16" />
                      </Box>
                    </Tooltip>
                  )}
                  <IconButton
                    variant="outlined"
                    border={'1px solid #00000033'}
                    borderRadius="50px"
                    w="34px"
                    h="34px"
                    minW="34px"
                    p={0}
                    icon={<ChatIcon width="16" height="16" />}
                    onClick={handleStartChatClick}
                  />
                  <IconButton
                    variant="outlined"
                    border={'1px solid #00000033'}
                    borderRadius="50px"
                    w="34px"
                    h="34px"
                    minW="34px"
                    p={0}
                    onClick={handleMeetNowClick}

                    icon={<MeetingDefaultIcon width="16" height="16" />}
                  />

                  {publicProfile?.appointment_profile && (
                    <IconButton
                      onClick={() => {
                        router.push(`/appointment/${publicProfile?.appointment_slug}`)
                      }}
                      variant="outlined"
                      border={'1px solid #00000033'}
                      borderRadius="50px"
                      w="34px"
                      h="34px"
                      minW="34px"
                      p={0}
                      icon={<BookAppointment width="16" height="16" />}
                    />
                  )}
                  <IconButton
                    variant="outlined"
                    border={'1px solid #00000033'}
                    borderRadius="50px"
                    w="34px"
                    h="34px"
                    minW="34px"
                    p={0}
                    icon={<CalendarIcon width="16" height="16" />}
                    as={Link}
                    onClick={() => handleScheduleMeeting()}
                  />
                </>
              )}
            </HStack>
          ) : (
            <HStack justifyContent="flex-end">
              {isHandshaked?.(publicProfile) ? (
                <>
                  <Tooltip label={publicProfile?.is_blocked ? "User is blocked" : (t('publicProfile.withdrawHandshake') || "Withdraw Handhsake")} bg="black" p={2}>
                    <Box
                      w={'34px'}
                      height={'34px'}
                      border={'1px solid #00000033'}
                      /* cursor="pointer" */
                      cursor={publicProfile?.is_blocked ? "not-allowed" : "pointer"}
                      opacity={publicProfile?.is_blocked ? 0.5 : 1}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      /* onClick={() => handleHandshakeSendRevoke(publicProfile)} */
                      onClick={publicProfile?.is_blocked ? undefined : () => handleHandshakeSendRevoke(publicProfile)}
                      sx={{
                        _hover: {
                          backgroundColor: publicProfile?.is_blocked ? "transparent" : "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <HandShakeSimpleIcon
                        width="16"
                        height="16"
                        color="rgb(179, 140, 140)"
                      />
                    </Box>
                  </Tooltip>
                  {/* <Button
                    variant="secondary"
                    leftIcon={
                      <HandShakeSimpleIcon
                        width="20"
                        height="20"
                        color="#E8BAB9"
                      />
                    }
                    // onClick={() => handshakeUser(publicProfile)}
                    onClick={() => handleHandshakeSendRevoke(publicProfile)}
                  >
                    Withdraw Handhsake
                  </Button> */}
                </>
              ) : (
                <>
                  {/* <Tooltip label={t('publicProfile.handshake') || "Handshake"} bg="black" p={2}> */}
                  <Tooltip label={publicProfile?.is_blocked ? "User is blocked" : (t('publicProfile.handshake') || "Handshake")} bg="black" p={2}>
                    <Box
                      w={'34px'}
                      height={'34px'}
                      border={'1px solid #00000033'}
                      /* cursor="pointer" */
                      cursor={publicProfile?.is_blocked ? "not-allowed" : "pointer"}
                      opacity={publicProfile?.is_blocked ? 0.5 : 1}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      /* onClick={() => handleProfileHandshake(publicProfile)} */
                      onClick={publicProfile?.is_blocked ? undefined : () => handleProfileHandshake(publicProfile)}
                      sx={{
                        _hover: {
                          /* backgroundColor: "#E4E6EB", */
                          backgroundColor: publicProfile?.is_blocked ? "transparent" : "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <HandShakeSimpleIcon
                        width="16"
                        height="16"
                        color="rgb(148, 176, 150)"
                      />
                    </Box>
                  </Tooltip>
                  {/* <Button
                  variant="secondary"
                  leftIcon={
                    <HandShakeSimpleIcon
                      width="20"
                      height="20"
                      color="#037F29"
                    />
                  }
                  // onClick={() => handshakeUser(publicProfile)}
                  onClick={() => handleProfileHandshake(publicProfile)}
                >
                  Handshake
                </Button> */}
                </>
              )}
            </HStack>
          )}
          {userProfileInfo?.id === publicProfile?.id ? (
            ''
          ) : (
            <HStack>
              <PublicProfileMenu>
                {isMobile ? <IconButton
                  height="34px"
                  width="34px"
                  minW="34px"
                  p={0}
                  border="1px solid #00000033"
                  borderRadius="50%"
                  icon={<HorizontalMenuIcon width="16" height="16" />}
                  variant="transparent"
                />  :<IconButton
                  variant="transparent"
                  p={0}
                  width="10px"
                  icon={<VerticalThreeDot width="10" height="20" />}
                />}
              </PublicProfileMenu>
            </HStack>
          )}
        </HStack>
      ) : (
        <>
          {userProfileInfo?.id === publicProfile?.id ? (
            ''
          ) : isFriend?.(publicProfile) ? (
            <HStack justifyContent="start">
              {!isMobile ? (
                <>
                  <Tooltip label={t('publicProfile.message') || "Message"} bg="black" p={2}>
                      <Box
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      // onClick={handleStartChatClick}
                      onClick={() => {
                        // const matrixUserId = getMatrixUserId(publicProfile?.id);
                        // setNullMatrixUser(publicProfile)

                        // if (!(publicProfile?.connection?.chat_room_id || matrixUserId)) {
                        //   setConfirmAction(() => (newId) => {
                        //     router.push(`/profile/message?user=${newId}`);
                        //   });
                        //   onOpen();
                        // } else {
                        //   router.push(`/profile/message?user=${publicProfile?.matrix_user_id || matrixUserId}`);
                        // }
                        const roomId =profileDataFromCircle?.connection?.room_id || getRoomIdFromLS(publicProfile?.id);
                        router.push(`/profile/message?user=${roomId}`);
                      }}
                      sx={{
                        _hover: {
                          backgroundColor: "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <ChatOutLined />
                    </Box>
                  </Tooltip>

                  {/* <Button
                    variant="secondary"
                    leftIcon={<ChatIcon width="20" height="20" />}
                    onClick={handleStartChatClick}
                  >
                    {/* Message *
                  </Button> 
                  */}
                  {/* <Button
                    onClick={handleMeetNowClick}
                    variant="secondary"
                    leftIcon={<MeetingDefaultIcon width="20" height="20" />}
                  >
                    {/* Meet Now 
                  </Button> */}
                  <Tooltip label={t('publicProfile.meeting') || "Meeting"} bg="black" p={2}>
                    <Box
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      onClick={handleMeetNowClick}
                      sx={{
                        _hover: {
                          backgroundColor: "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <MeetingDefaultIcon
                        height={'18px'}
                        width={'18px'}
                      />
                    </Box>
                  </Tooltip>

                  {isFriend?.(publicProfile) && (
                    <Tooltip label={t('settingsIntegration.connect')} bg="black" p={2}>
                      <Box
                        w={'41px'}
                        height={'41px'}
                        border={'1px solid #00000033'}
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius={'50%'}
                        // onClick={(e) => {
                        //   if (!publicProfile?.matrix_user_id) {
                        //     onOpen(); // show matrix popup
                        //   } else {
                        //     initiateCall(publicProfile?.matrix_user_id, 'audio')
                        //   }
                        // }}
                        onClick={() => {
                          // const matrixUserId = getMatrixUserId(publicProfile?.id);
                          // setNullMatrixUser(publicProfile)

                          // if (!(publicProfile?.connection?.chat_room_id || matrixUserId)) {
                          //   setConfirmAction(() => (newId) => {
                          //     initiateCall(newId, 'audio');
                          //   });
                          //   onOpen();
                          // } else {
                          //   initiateCall(publicProfile?.matrix_user_id || matrixUserId, 'audio');
                          // }
                          initiateCall(publicProfile);
                        }}
                        sx={{
                          _hover: {
                            backgroundColor: "#E4E6EB",
                            color: "inherit",
                          },
                        }}
                      >
                        <CallIconNew
                          height={'18px'}
                          width={'18px'}
                        />
                      </Box>
                    </Tooltip>
                  )}

                  {publicProfile?.appointment_profile && (
                    <Tooltip label={t('publicProfile.bookAppointment') || "BookAppointment"} bg="black" p={2}>
                      <Box
                        w={'41px'}
                        height={'41px'}
                        border={'1px solid #00000033'}
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius={'50%'}
                        onClick={() => {
                          router.push(`/appointment/${publicProfile?.appointment_slug}`)
                        }}
                        sx={{
                          _hover: {
                            backgroundColor: "#E4E6EB",
                            color: "inherit",
                          },
                        }}
                      >

                        <BookAppointment
                          height={'18px'}
                          width={'18px'}
                        />
                      </Box>
                    </Tooltip>
                    // <Button
                    //   onClick={() => {
                    //     router.push(`/appointment/${publicProfile?.appointment_slug}`)
                    //   }}
                    //   variant="secondary"
                    //   leftIcon={<BookAppointment width="20" height="20" />}
                    // >
                    //   Book Appointment
                    // </Button>
                  )}
                  {/* <Button
                    variant="secondary"
                    leftIcon={<CalendarIcon width="20" height="20" />}
                    as={Link}
                    onClick={() => handleScheduleMeeting()}
                  >
                    {/* Schedule *
                  </Button> */}
                  {/* <Tooltip label="Schedule Meeting" bg="black" p={2}>

                    <Box
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      sx={{
                        _hover: {
                          backgroundColor: "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                    >
                      <ScheduleIcon
                        height={'18px'}
                        width={'18px'}
                        onClick={() => handleScheduleMeeting()} />
                    </Box>
                  </Tooltip> */}

                </>
              ) : (
                <>
                  <IconButton
                    variant="secondary"
                    icon={<ChatIcon width="20" height="20" />}
                    onClick={handleStartChatClick}
                  />
                  <IconButton
                    onClick={handleMeetNowClick}
                    variant="secondary"
                    icon={<MeetingDefaultIcon width="20" height="20" />}
                  />
                  {publicProfile?.appointment_profile && (
                    <IconButton
                      onClick={() => {
                        router.push(`/appointment/${publicProfile?.appointment_slug}`)
                      }}
                      variant="secondary"
                      icon={<BookAppointment width="22" height="22" />}
                    />
                  )}
                  <IconButton
                    variant="secondary"
                    icon={<CalendarIcon width="20" height="20" />}
                    as={Link}
                    onClick={() => handleScheduleMeeting()}
                  />
                </>
              )}
            </HStack>
          ) : (
            <HStack justifyContent="flex-end">
              <>
                {/* <Button
                  variant="secondary"
                  leftIcon={
                    <ReminderIcon
                      width="18"
                      height="18"
                      color="#3D5A80"
                    />
                  }
                >
                  Reminder
                </Button> */}
                {isHandshaked?.(publicProfile) ? (
                  !isHandshakeRequested(publicProfile) ? (
                  <HStack justifyContent={["center","flex-start"]} >
                    <Tooltip label={t('profileNetwork.ignore') || "Ignore"}>
                      <IconButton
                        onClick={() => {
                          if(pendingInvitations && publicProfile){
                            const user = getRequestedAndSenderUserInfoFromUser(publicProfile, pendingInvitations)
                            rejectInvitation?.(user);
                          }
                        }}
                        bg="none"
                        isLoading={
                          rejectInvitationLoading
                        }
                        width="30px"
                        height="40px"
                        borderRadius="50%"
                        border="1px solid #00000033"
                        icon={<IgnoreNewIcon />}
                      />
                    </Tooltip>

                    <Tooltip label={t('profileNetwork.accept') || "Accept"}>
                      <IconButton
                        bg="none"
                        width="30px"
                        height="40px"
                        borderRadius="50%"
                        border="1px solid #00000033"
                        isLoading={
                          acceptInvitationLoading
                        }
                        /* onClick={() => {
                          if(pendingInvitations && publicProfile){
                            const user = getRequestedAndSenderUserInfoFromUser(publicProfile, pendingInvitations)
                            acceptInvitation(user);
                          }
                        }} */
                        type="button"
                        onClick={async (e) => {
                          e?.preventDefault?.();
                          if(pendingInvitations && publicProfile){
                            const user = getRequestedAndSenderUserInfoFromUser(publicProfile, pendingInvitations);
                            await acceptInvitation(user);
                            refetchPublicProfile?.();
                          }
                        }}
                        icon={<AcceptNewIcon />}
                      />
                    </Tooltip>
                  </HStack> 
                  ) : (
                    <Tooltip label={publicProfile?.is_blocked ? "User is blocked" : (t('publicProfile.withdrawHandshake') || "Withdraw Handhsake")} bg="black" p={2}>
                      <Box
                        w={'41px'}
                        height={'41px'}
                        border={'1px solid #00000033'}
                        /* cursor="pointer" */
                        cursor={publicProfile?.is_blocked ? "not-allowed" : "pointer"}
                        opacity={publicProfile?.is_blocked ? 0.5 : 1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius={'50%'}
                        /* onClick={() => handleHandshakeSendRevoke(publicProfile)} */
                        onClick={publicProfile?.is_blocked ? undefined : () => handleHandshakeSendRevoke(publicProfile)}
                        sx={{
                          _hover: {
                            /* backgroundColor: "#E4E6EB", */
                            backgroundColor: publicProfile?.is_blocked ? "transparent" : "#E4E6EB",
                            color: "inherit",
                          },
                        }}
                      >
                        <HandShakeSimpleIcon
                          width="20"
                          height="20"
                          color="rgb(179, 140, 140)"
                        />
                      </Box>
                    </Tooltip>
                  )
                ) : (
                  <>
                    <ForceSignInWrapper>
                      {/* <Tooltip label={t('publicProfile.handshake') || "Handshake"} bg="black" p={2}> */}
                      <Tooltip label={publicProfile?.is_blocked ? "User is blocked" : (t('publicProfile.handshake') || "Handshake")} bg="black" p={2}>
                        <Box
                          w={'41px'}
                          height={'41px'}
                          border={'1px solid #00000033'}
                          /* cursor="pointer" */
                          cursor={publicProfile?.is_blocked ? "not-allowed" : "pointer"}
                          opacity={publicProfile?.is_blocked ? 0.5 : 1}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          borderRadius={'50%'}
                          /* onClick={() => handleProfileHandshake(publicProfile)} */
                          onClick={publicProfile?.is_blocked ? undefined : () => handleProfileHandshake(publicProfile)}
                          sx={{
                            _hover: {
                              /* backgroundColor: "#E4E6EB", */
                              backgroundColor: publicProfile?.is_blocked ? "transparent" : "#E4E6EB",
                              color: "inherit",
                            },
                          }}
                        >
                          <HandShakeSimpleIcon
                            width="20"
                            height="20"
                            color="rgb(148, 176, 150)"
                          />
                        </Box>
                      </Tooltip>
                    </ForceSignInWrapper>

                    {/* <Button
                    variant="secondary"
                    leftIcon={
                      <HandShakeSimpleIcon
                        width="20"
                        height="20"
                        color="#037F29"
                      />
                    }
                    // onClick={() => handshakeUser(publicProfile)}
                    onClick={() => handleProfileHandshake(publicProfile)}
                  >
                    Handshake
                  </Button> */}
                  </>
                )}
                {/* <ForceSignInWrapper> */}
                  {publicProfile?.appointment_profile && <Tooltip label={t('publicProfile.bookAppointment') || "Book Appointment"} bg="black" p={2}>
                    <Box
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      sx={{
                        _hover: {
                          backgroundColor: "#E4E6EB",
                          color: "inherit",
                        },
                      }}
                      onClick={() => {
                        router.push(`/appointment/${publicProfile?.appointment_slug}`)
                      }}
                    >
                      <BookAppointment width="20" height="20" />
                    </Box>
                  </Tooltip>}
                {/* </ForceSignInWrapper> */}
                {/* <Button
                  onClick={() => {
                    router.push(`/appointment/${publicProfile?.appointment_slug}`)
                  }}
                  variant="secondary"
                  leftIcon={<BookAppointment width="20" height="20" />}
                >
                  Book Appointment
                </Button> */}
              </>
            </HStack>
          )}
          {userProfileInfo?.id === publicProfile?.id ? (
            ''
          ) : (
            <HStack pos="relative" zIndex="8">
              <PublicProfileMenu>
                <IconButton
                  w={'40px'}
                  variant="none"
                  height={'40px'}
                  border={'1px solid #00000033'}
                  cursor="pointer"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius={'50%'}
                  // p={0}

                  _hover={{
                    bg: "gray.100"
                  }}
                  // width="10px"
                  icon={loadingPDF ? <Spinner size="sm" /> :<ThreeDot width="20" height="20" />}
                />
              </PublicProfileMenu>
            </HStack>
          )}
        </>
      )}
      {handshakeMessageDisc?.isOpen && <HandshakeUserModal />}
      
      <GlobalMatrixPopup
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={confirmAction}
        selectedUserId={nullMatrixUser?.id}
      />
    </Stack>
  );
};

export default RightProfileActionsPublic;
